// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifos.mobile.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import de.jensklingenberg.ktorfit.annotationsAttributeKey
import de.jensklingenberg.ktorfit.converter.TypeData
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.client.request.setBody
import io.ktor.http.HttpMethod
import io.ktor.http.URLBuilder
import io.ktor.http.decodeURLQueryComponent
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.OptIn
import kotlin.Suppress
import org.mifos.mobile.core.model.entity.User
import org.mifos.mobile.core.model.entity.payload.LoginPayload

@OptIn(InternalKtorfitApi::class)
public class _AuthenticationServiceImpl(
  private val _ktorfit: Ktorfit,
) : AuthenticationService {
  private val _helper: KtorfitConverterHelper = KtorfitConverterHelper(_ktorfit)

  override suspend fun authenticate(loginPayload: LoginPayload): User {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("POST")
        url{
        takeFrom(_ktorfit.baseUrl + "authentication")
        }
        setBody(loginPayload) 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<User>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }
}

public class _AuthenticationServiceProvider : ClassProvider<AuthenticationService> {
  override fun create(_ktorfit: Ktorfit): AuthenticationService = _AuthenticationServiceImpl(_ktorfit)
}

public fun Ktorfit.createAuthenticationService(): AuthenticationService = _AuthenticationServiceImpl(this)
